import React, { useState, useEffect } from "react";
import { Calendar, Button, Modal, Badge, Input, Select, Tag } from "antd";
import moment from "moment";
import { EditOutlined } from '@ant-design/icons';
import { useDispatch, useSelector } from "react-redux";
import { getAllCalendar } from "../../redux/actions/Calendar.action";
import { ReadCookie } from "../../utils/readCookie";
import { TabTitle } from "../../utils/GeneralFunction";



const EventCalendar = () => {
    TabTitle("Calendar")
    const token = ReadCookie("token");
    const dispatch = useDispatch()
    const { calendar } = useSelector(state => state)
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [currentMonth, setCurrentMonth] = useState(moment());
    const [itemData, setItemData] = useState(null);
   

    const handleDateClick = (date) => {
        let formatedDate = moment(date).format("YYYY-MM-DD");
        // setSelectedDate(formatedDate);

        // Check if the selected date is in the currently visible month
        if (date.month() === currentMonth.month() && date.year() === currentMonth.year()) {

            let findItem = calendar?.payload?.data?.find((v) => moment(v.date).format("YYYY-MM-DD") === formatedDate);
            //   If FindItem It means EDIT Mode
            if (findItem) {
                setItemData(findItem);
                setIsModalOpen(true);
            }

        }
    };

    const handlePanelChange = (date) => {
        setCurrentMonth(date); // Update the visible month when navigating
    };


    // CALENDER
    const dateCellRender = (value) => {
        const stringValue = value.format("YYYY-MM-DD");
        const listData = calendar?.payload?.data?.filter(({ date }) => moment(date).format("YYYY-MM-DD") === stringValue);
        return (
            <div >
                {listData?.map((item, idx) => (
                    <div key={idx}>
                        {
                            item?.events?.map((val, id) => {
                                return (
                                    <div key={id}><Badge
                                        color={
                                            val.status === "High"
                                                ? "red"
                                                : val.status === "Medium"
                                                    ? "orange"
                                                    : "green"
                                        }
                                        text={val.event} />
                                    </div>
                                )
                            })
                        }

                    </div>
                ))}
            </div>
        );
    };

    const okHandler = () => {
        setIsModalOpen(false);
    }


    useEffect(() => {
        dispatch(getAllCalendar(token, { from_date: "2018-01-01", to_date: "2050-01-01" }))
    }, [])


    return (
        <div >
            <div style={{ fontSize: 20 }}>Calendar</div>
            <Calendar
                dateCellRender={dateCellRender}
                onSelect={handleDateClick}  // Fires only when clicking a date cell
                onPanelChange={handlePanelChange}  // Track visible month
            />
            <Modal width={"50%"} title={`Date : ${moment(itemData?.date).format("MM-DD-YYYY")}`} visible={isModalOpen} onCancel={() => setIsModalOpen(false)} onOk={okHandler}>
                <div className='modal_body'>
                    {itemData?.events.map((item, idx) => {
                        return <div key={idx} style={{ marginTop: 10 }}>
                            <div
                                style={{
                                    border: "1px solid gray",
                                    // borderRadius: 10,
                                    padding: 10,
                                    display: "flex",
                                    justifyContent: "space-between",
                                }}
                            >
                                <div> {idx + 1}) {item.event}</div>
                                <Tag
                                    color={
                                        item.status === "High"
                                            ? "error"
                                            : item.status === "Medium"
                                                ? "warning"
                                                : "success"
                                    }
                                >
                                    {item.status}
                                </Tag>
                            </div>
                        </div>
                    })}
                </div>
            </Modal>
        </div>
    );
};

export default EventCalendar;
